import React from 'react';
import { Box, Typography, Grid, Avatar } from '@mui/material';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Events from '../components/Events';

const Home = ({ events = [] }) => {
    return (
        <div>
            <Navbar />
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100vh',
                    backgroundImage:
                        'linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url(https://lh3.googleusercontent.com/rd-d/ALs6j_HxRZHwC5DXmCicUM8FTzaF79K7HAzjJnaNEtdlqSjpbk48mSuScvPmBhl464snyrYusp23fycuCA3n1NUtOAqgytLHg6OSmhma9rX3m7TsWPafL0piXW-HI5wFHKujgOsxEBeftXJ4sMTNyK6hAFwzXfrx_vE2BDhtRLMUEEVBOuvMriX7_X1ZJnSI-X8MC_c_qvVPFQpByq99rPQ655qmrtOai7azBrpqN6YnLSfopF4yPxCANcGau97fYV5qHHq8ZutX7uhKnbyfp9FWuRYi9FSylVZWIH9szd4_-L-FfE6sAy0JiqzKg8OljPjy8N0W-vyrV7J5iEfqtquowkgO7MFR1V8HxdL2ee_xHBj6CfwS0Jis1GBRu3zFsD9h-TKRhaXTbfrlmIfRA_WimPUaTMCddnCHHdU3O0lkwJ4qNvDw1mfWV_Iw0vrd4Ex_tNyK2y61hpHCD08t--oabjobv2qruIHMYeE5PpyKytFPsjBWZTBwD2eBYeSV68SL1GKF2TjnimNFYNFV9D8c0Q8Kxe4MDyic0-ZOAycuJWwQ-Q2tJ72xRy4qmnbrXyQSheUZgJpHKDUNj2L53a6GneCZoXB55PLsgtiqVclufniZ8Rk7m28xxKHGgD3lvk-oIEj5i36n6KaAWIYS2FQFm-UWE6GkRHgcHHrkunrEI6NtHJO0LcGox4i7sUnrySBrGFgFgi2jL18zE8KOjhgv8lDSeQ7ktlKtWXiqo2moTMV5fYPqWIUzCF4y6-YMBjGNsj_tzmN4ZkgkEjQJfEpFm2X3GDhDUZHm9wsbJoxA1yOQ1JZwU8A4JkZzq5X8NWUWyzE2OHw02eQY18zAi-DIPwAHLe2MbREPErVBwUDEB_cMJ_Uws1311vakBCRYigDhlteXhNGXwEKf3Jj-OQ7wZH_9PL0an1-Wtxyuw5yciSer64ix1eTmBsQMMGEDx1GRHJDAzOirjPkpsFbZxf8EVbk04BxVf0KTPpF0Mp-Fg3Blhl0XFy1tvxoeux2mkX7Hdfdn2RMSoKC-2eXrI8e9cWjAarmzJ-MFQxyKDGWMGb1wRbDNl-jg_FCXjq2Yi9_EQaGRiEwaVNbYncHdBBoXvBvZfRya6YhxpddPBnKK_JKPZaVVXybdvv1U6SZUjoJMEE8sgq1ryju66w=w2940-h1838?auditContext=forDisplay)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    color: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    zIndex: -1,
                }}
            >
                <Box sx={{ transform: 'translateY(-30%)' }}>
                    <Typography variant="h2" component="h1" gutterBottom>
                        Japanese Student Association @ NC State
                    </Typography>
                </Box>
            </Box>

            <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0)', minHeight: '75vh' }} />

            <Box sx={{ backgroundColor: '#f9f9f9', minHeight: '100vh' , overflowX: 'hidden', width: '100%', maxWidth: '100vw' }}>
                <Box sx={{width: '90%', mx: 'auto', paddingTop: 5}}>
                    <Box>
                        <Typography variant="h2" component="h1" gutterBottom textAlign="center">
                            About Us
                        </Typography>
                        <Typography variant="body1">
                            JSA is a non-profit student organization aimed at promoting Japanese culture at NC State.
                            Our goal is to create a welcoming environment for students of all backgrounds to experience cultural 
                            events and connect with the local Japanese community.
                        </Typography>
                        <br/>
                        <Typography variant="body1">
                                We host various cultural events throughout the academic year to provide opportunities
                            for students to engage with the culture, build community, and, of course, to have fun! We also collaborate
                            with other student organizations to increase outreach and offer new cross-cultural experiences.
                        </Typography>
                    </Box>
                    <Box sx={{display: 'flex', flexDirection: 'row', paddingTop: 5}}>
                        <Grid
                            container
                            spacing={2}
                            columns={16}
                            sx={{ alignItems: 'stretch' }}
                        >
                            <Grid size={{ xs: 16, md: 8 }}>
                                <Events events={events} />
                            </Grid>
                            <Grid
                                size={{ xs: 16, md: 8 }}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    position: 'relative',
                                    top: '-5%'
                                }}
                            >
                                <Box>
                                    <Typography variant="h2" component="h1" gutterBottom textAlign="center">
                                        Club Activities
                                    </Typography>
                                    <Typography variant="body1">
                                        Our club activites include events like a Moonlight Festival Night, Field Day, Karaoke Night, and more!
                                        We also hold fundraisers, such as our Yakisoba Social and Onigiri Sale. To keep up to date with out upcoming events,
                                        be sure to follow us on Instagram or join our Discord server!
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ paddingTop: 5, paddingBottom: 5, justifyContent: 'center'}}>
                        <Typography variant="h2" component="h1" gutterBottom textAlign="center">
                            Our Sponsors
                        </Typography>
                        <Typography variant="body1" sx={{textAlign: 'center', paddingBottom: '8px'}}>
                            Thank you to Toyo Shokuhin and the Japanese Language School of Raleigh for supporting our activities!
                        </Typography>
                        <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                            <a href="https://toyoshokuhin.store/" target="_blank" rel="noopener noreferrer">
                                <Avatar
                                    src="/toyo-logo.png"
                                    alt="Toyo Logo"
                                    sx={{ width: 90, height: 90, paddingRight: '12px', cursor: 'pointer' }}
                                />
                            </a>

                            <a href="https://www.japanschoolraleigh.com/english.html" target="_blank" rel="noopener noreferrer">
                                <Avatar
                                    src="/jlsr-logo.jpg"
                                    alt="JLSR Logo"
                                    sx={{ width: 90, height: 90, cursor: 'pointer' }}
                                />
                            </a>
                        </Box>
                    </Box>
                </Box>
            </Box>

            <Footer />
        </div>
    );
};

export default Home;
